import React, { useEffect, useRef, useState } from 'react'
import { CallApi } from '../../../../Components/common/CommonFunctions';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faPencil, faTrash, faStar } from '@fortawesome/free-solid-svg-icons';
import { Container, Row, Col, Modal, Form, Button, Table, Accordion, Badge } from 'react-bootstrap';

import { ReactComponent as UserIcon } from "../../../../assets/images/icon_svg/user_history.svg";

import { ReactComponent as EditIcon } from "../../../../assets/images/icon_svg/edit_history.svg";
import { ReactComponent as UploadIcon } from "../../../../assets/images/icon_svg/upload_history.svg";
import { ReactComponent as TaskIcon } from "../../../../assets/images/icon_svg/task_history.svg";
import { ReactComponent as AssignIcon } from "../../../../assets/images/icon_svg/assign_history.svg";
import { ReactComponent as FlagIcon } from "../../../../assets/images/icon_svg/update_history.svg";
import { ReactComponent as CloseIcon } from "../../../../assets/images/icon_svg/close_history.svg";
import { ReactComponent as ReopenIcon } from "../../../../assets/images/icon_svg/reopen_history.svg";
import Select from 'react-select';

const History = ({ propData, recordId }) => {

  const isMounted = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const [history, setHistory] = useState({});
  const [selectedAction, setSelectedAction] = useState(null);

  const loadHistory = (atype) => {
    setIsLoading(true);
    CallApi({
      endPoint: `v2/service-recovery/activity-list?pagenum=0&pagesize=25&record_id=${recordId}&actionType=${atype ?? null}`,
      method: 'GET',
      // payload: { service_recovery_id: detID.service_recovery_id },
      onSuccess: (res) => {
        const innerData = res.data;
        setHistory(innerData)
        setIsLoading(false);
      },
      onError: (msg) => toast.error(msg)
    });
  }

  useEffect(() => {
    if (isMounted.current) return;
    loadHistory();
    isMounted.current = true;
  }, []);

  const iconStatus = {
    editicon: <EditIcon />,
    uploadicon: <UploadIcon />,
    taskicon: <TaskIcon />,
    assignicon: <AssignIcon />,
    flagicon: <FlagIcon />,
    closeicon: <CloseIcon />,
    reopenicon: <ReopenIcon />,
  }

  return (
    <div className='historydv'>
      <div className="stats-bar">
        <div className="stat">
          <span className="stat-label">Total Entries</span>
          <span className="stat-value">{history?.dashboardData?.total_entries}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Last Activity</span>
          <span className="stat-value dark">{history?.dashboardData?.latest_activity}</span>
          <span className="stat-sub"> 
          {propData?.is_recovery_closed && (
          <> Record Closed · {history?.dashboardData?.closed_user}</>
          )}
          </span>
        </div>
        <div className="stat">
          <span className="stat-label">Most Active</span>
          <span className="stat-value dark">{history?.dashboardData?.most_activities_user}</span>
          <span className="stat-sub">{history?.dashboardData?.most_activities_user_count} actions</span>
        </div>
        <div className="spacer"></div>
        <div className="dropdown">
          <Select
            options={[
              { label: `All Actions`, value: null },
              ...(history?.actionTypeList || [])
            ]}
            value={
              [
                { label: `All Actions (${history?.actionTypeList?.length})`, value: null },
                ...(history?.actionTypeList || [])
              ].find(option => option.value == selectedAction) || null}
            onChange={selected => {setSelectedAction(selected ? selected.value : null); loadHistory(selected.value)}}
            // placeholder="example@gmail.com"
            className='select-dropdown'
          // value={getEmail.find(option => option.value === selectedOpt)}
          />
          {/* All Actions (18)
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9" /></svg> */}
        </div>
      </div>
      <div className="log-list min-hgt-65 max-hgt-65">
        {history?.response_data?.map((h, index) => (
          <div className="log-row" key={h.action_type + '_' + index}>
            <div className="log-user">
              <div className="user-row">
                <UserIcon />
                <span className="user-name">{h.updated_by}</span>
              </div>
              <span className="user-time">{h.updated_at}</span>
            </div>
            <div className="col-divider"></div>
            <div className="log-action">
              <span className={`action-badge ${h.icon_class}`}> {/* record-edited */}
                {/* <EditIcon /> */}
                {iconStatus[h.icon_name]}
                {h.action_type}
              </span>
            </div>
            <div className="col-divider"></div>
            <div className="log-desc">
              <ul>
                {h?.changes_details?.map((d, index) => (
                  <li key={index}  dangerouslySetInnerHTML={{ __html: d }}></li>
                ))}
              </ul>
            </div>

          </div>
        ))}
      </div>

      {/* <div className="log-row">
        <div className="log-user">
          <div className="user-row">
            <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
            <span className="user-name">R. Okonkwo</span>
          </div>
          <span className="user-time">2026-05-21 13:28 UTC</span>
        </div>
        <div className="col-divider"></div>
        <div className="log-action">
          <span className="action-badge attachment-uploaded">
            <svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>
            Attachment Uploaded
          </span>
        </div>
        <div className="col-divider"></div>
        <div className="log-desc">Priority level updated from Low <span className="arrow">→</span> High</div>

      </div> */}



    </div>
  )
}

export default History